<template>
  <div class="caseimgmain">
    <div class="titlePart">
      <h2 class="title">高铁南京南站</h2>
      <div class="intro">
          南京南站位于江苏省南京市雨花台区，占地面积约70万平方米，总建筑面积73万平方米，站房总建筑面积约45.8万平方米，其中主站房面积达38.7万平方米，是华东地区最大的交通枢纽，也是亚洲第一大火车站和亚洲第一大高铁站。
      </div>
    </div>
    <div class="casebutlist" style="margin-top:5rem">
      <div
        class="caseButton wow animate__zoomIn"
        v-for="(item, index) in list.slice(0,4)"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="casebutlist" style="margin-bottom:5rem">
      <div
        class="caseButton wow animate__zoomIn"
        v-for="(item, index) in list.slice(4)"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="imgBox">
      <el-row class="elRow" :gutter="30" type="flex" align="center" justify='center'>
        <viewer :images="srcListArr" class="viewerImg" style="height: 100%">
          <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16" align="center">
            <div class="innerBox">
              <div
                class="leftTopBox"
                v-for="(sItem, i) in srcListArr[0].children[0].children"
                :key="i"
              >
                <img :src="sItem.src" title="查看大图" />
              </div>
            </div>
            <div class="innerBox">
              <img :src="srcListArr[0].children[1].src" title="查看大图" />
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="center">
            <div class="innerBox colImgbox">
              <img :src="srcListArr[1].src" title="查看大图" />
            </div>
          </el-col>
        </viewer>
      </el-row>
    </div>
    <div class="countRow">
      <div
        class="countPanel wow animate__zoomIn"
        v-for="(item, index) in panelData"
        :key="index"
      >
        <div class="panelCount">{{ item.count }}</div>
        <div class="panelTitle">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  data() {
    return {
      list: ["火灾自动报警系统", "电气火灾系统", "水系统", "视频系统",'防排烟系统','防火门系统','EPS监测系统'],
      panelData: [
        { count: "10+", desc: "整体站房及驻站单位" },
        { count: "15", desc: "报警主机" },
        { count: "8000+", desc: "消防点位" },
        { count: "100+", desc: "消防点位" },
      ],
      activeIndex: -1,
      srcListArr: [
        {
          children: [
            {
              src: "",
              children: [
                {
                  src: require("../../assets/img/case/pic3.jpeg"),
                },
                {
                  src: require("../../assets/img/case/pic24.png"),
                },
              ],
            },
            {
              src: require("../../assets/img/case/3541619596313_.pic_hd.jpg"),
              children: [],
            },
          ],
        },
        {
          src: require("../../assets/img/case/4.jpeg"),
          name: "",
          children: [],
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false}).init();
  },
  watch: {},
  methods: {
    showModel() {
      this.dialogVisible = true;
    },
  },
  components: {},
};
</script>
<style lang='scss'  scoped>
.caseimgmain {
  background: #f6f8fa;
  height: 100%;
  box-sizing: border-box;
  padding: 0 14% 5%;
  .titlePart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      line-height: 4.2rem;
      margin-bottom: 1rem;
    }
    .intro {
      width: 70%;
      color: #999999;
      text-align: center;
      font-size: 1.4rem;
      line-height: 2.2rem;
    }
  }
  .casebutlist {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 25%;
    .caseButton {
      background: #ffffff;
      color: #00a087;
      padding: 0.5rem 3rem;
      border-radius: 24px;
      font-size: 1.4rem;
      font-weight: bold;
      letter-spacing: 0.15rem;
      margin: 1rem;
      box-shadow: 0px 5px 32px 0px rgba(202, 202, 202, 0.34);
      cursor: pointer;
    }
  }
  .imgBox {
    margin-bottom: 5rem;
    .elRow {
      display: flex;
      flex-wrap: wrap;
    }
    .innerBox {
      position: relative;
      margin-top: 3rem;
      width: 100%;
      height: 27rem;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        cursor: pointer;
        object-fit: cover;
      }
      .leftTopBox {
        width: 48%;
        position: relative;
        .smallEye {
          position: absolute;
          bottom: 0rem;
          right: 0rem;
          cursor: pointer;
          background: #18b09b;
          width: 3rem;
          height: 3rem;
          border-radius: 0 0 4px 0;
        }
      }
    }

    .colImgbox {
      height: 56rem;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
    
  }
  .countRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    .countPanel {
      background: #ffffff;
      box-shadow: 0px 7px 70px 0px rgba(201, 217, 222, 0.39);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      width: 23%;
      height: 12rem;
      &:hover {
        box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
        transform: translate(0, -5px);
        transition: all 0.3s;
      }
      .panelCount {
        font-weight: bold;
        color: #333333;
        line-height: 2.4rem;
        font-size: 2.4rem;
      }
      .panelTitle {
        color: #999999;
        font-size: 1.4rem;
        margin-top: 2rem;
        padding: 0 2rem;
        height: 3rem;
        text-align: center;
      }
    }
    .activePanel {
      background: linear-gradient(125deg, #00b7a4, #0dca81);
      box-shadow: 0px 5px 32px 0px rgba(47, 189, 141, 0.34);
      .panelCount,
      .panelTitle {
        color: #ffffff !important;
      }
    }
  }

  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    text-align: center;
  }
  /deep/ .el-dialog__title {
    display: none;
  }
}
@import '../../assets/responsive/case.scss'
</style>